import LoginPage from '../../login/pages/LoginPage';
import ForgotPage from '../../login/pages/ForgotPage';
import ReportPage from '../../login/pages/ReportPage';
import HelpPage from '../../login/pages/HelpPage';
import { RequireUnauth } from '../components/RequireUnauth';
import { RequireAuth } from '../components/RequireAuth';

export const reportRoutes = [
  {
    path: '*',
    element: (
      <RequireAuth>
        <ReportPage />
      </RequireAuth>
    ),
  },
  {
    path: '/login',
    element: (
      <RequireUnauth>
        <LoginPage />
      </RequireUnauth>
    ),
  },
  {
    path: '/forgot',
    element: (
      <RequireUnauth>
        <ForgotPage />
      </RequireUnauth>
    ),
  },
  {
    path: '/report',
    element: (
      <RequireAuth>
        <ReportPage />
      </RequireAuth>
    ),
  },
  {
    path: '/help',
    element: <HelpPage />,
  },
];
